/**
 * Dynamic query for marketplace_orgs with filtering support
 */
const orgsQuery = `
query MarketplaceOrgs($first: Int!, $skip: Int, $where: Marketplace_orgWhereInput, $order: [Marketplace_orgOrder!]) {
  marketplace_orgs(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    edges {
      node {
        objectId
        name
        vat_code
        city
        country
        province
        street
        is_active
        marketplace_seller_pointer {
          objectId
          name
        }
        org_pointer {
          objectId
          nome
        }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default orgsQuery;
